import { render } from "./ExpertStatisticsCallerNumbers.vue?vue&type=template&id=e0c41fee"
import script from "./ExpertStatisticsCallerNumbers.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsCallerNumbers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__